import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom"; // ← Add this

import { BackIcon, SearchFilterIconMob, SearchIcon } from "../assets/Icons";
import FilterTab from "./Filter";

const filterData = [
  {
    name: "Category",
    tags: [
      { key: "cat1", name: "Design", value: "design" },
      { key: "cat2", name: "Development", value: "development" },
      { key: "cat3", name: "Marketing", value: "marketing" },
    ],
  },
  {
    name: "Status",
    tags: [
      { key: "status1", name: "Active", value: "active" },
      { key: "status2", name: "Pending", value: "pending" },
    ],
  },
];

const HeaderMobileSearch = ({
  showFilterBtn = false,
  backBtn = false,
  activeTab,
  handleResetCheckBox,
  handleSelectApplication,
  ...rest
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const history = useHistory();
  const handleCheckboxChange = (item) => {
    setSelectedCheckboxes((prevSelected) => {
      const exists = prevSelected.find((i) => i.key === item.key);
      if (exists) {
        return prevSelected.filter((i) => i.key !== item.key);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleReset = () => {
    setSelectedCheckboxes([]);
  };

  const openFilter = () => {
    setShowFilter(true);
  };

 useEffect(() => {
   const handleScroll = () => {
     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
 
     if (scrollTop === 0) {
       setScrollDirection("scroll-default");
     } else if (scrollTop > lastScrollTop) {
       setScrollDirection("up");
     } else if (scrollTop < lastScrollTop) {
       setScrollDirection("down");
     }
 
     setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop);
   };
 
   window.addEventListener("scroll", handleScroll);
   return () => window.removeEventListener("scroll", handleScroll);
 }, [lastScrollTop]);

  return (
    <>
        <div
          className={`header-mob ${
            scrollDirection === "up" ? "scroll-up" : scrollDirection === "down" ? "scroll-down" : "scroll-default"
          }`}
        >
        <div className="with-backBtn">
          {backBtn && (
            <div className="back-btn-wrapper" onClick={() => history.goBack()}>
              <span className="backbtn">
                <BackIcon />
              </span>
            </div>
          )}
          <div className={showFilter ? "searchMobile" : "searchMobile noFilter"}>
            <input
              type="text"
              placeholder="Search"
              {...rest}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <span className="searchIcon">
              <SearchIcon />
            </span>

            {showFilterBtn && (
              <span className="filterIcon" onClick={openFilter}>
                <SearchFilterIconMob />
                {<span className="filter-active-span"></span>}
              </span>
            )}
          </div>
        </div>
      </div>

      <FilterTab
        selectedCheckboxes={selectedCheckboxes}
        setSelectedCheckboxes={handleCheckboxChange}
        filterOptions={filterData}
        onToggleFilter={() => setShowFilter(false)}
        showfilter={showFilter}
        handleResetCheckBox={handleReset}
      />
    </>
  );
};

export default HeaderMobileSearch;
